import { createSlice } from '@reduxjs/toolkit';

const initialState = false;

export const submitSlice = createSlice({
  name: 'isSubmitting',
  initialState,
  reducers: {
    startSubmitting: () => true,
    stopSubmitting: () => false,
  },
});

export const { startSubmitting, stopSubmitting } = submitSlice.actions;
